// extracted by mini-css-extract-plugin
module.exports = {"headingDiv":"styles_headingDiv__lzaXR","CardDiv":"styles_CardDiv__xg72f","buttonBorder":"styles_buttonBorder__tlr4R","forCreator":"styles_forCreator__vzmtC"};